import tochtApi from "../../../api/zoekmotor/tochtApi";
import tochtTypeApi from "../../../api/shared/tochtTypeApi";
import lusTypeApi from "../../../api/shared/lusTypeApi";
import moment from "moment";
import queryString from "query-string";

export default class OverzichtPageHelper {

    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const search = window.location.search ? window.location.search : window.parent.location.search;
        const parsedQueryString = queryString.parse(search.toLowerCase());
        const provincieId = parsedQueryString.provincieid ? parsedQueryString.provincieid : null;
        const startDatum = parsedQueryString.startdatum ? parsedQueryString.startdatum : null;
        const eindDatum = parsedQueryString.einddatum ? parsedQueryString.einddatum : null;
        const filter = this.createFilter(provincieId, startDatum, eindDatum, 1, 12);

        this.listPublishedTochtenByFilter(filter);
        this.loadTochtTypes();
        this.loadLusTypes();
    }

    loadTochtTypes() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        ajaxActions.started();
        tochtTypeApi.getTochtTypes()
            .then((response) => {
                ajaxActions.ended();
                context.setState({ tochtTypes: response.data });
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    loadLusTypes() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        ajaxActions.started();
        lusTypeApi.getLusTypes()
            .then((response) => {
                ajaxActions.ended();
                context.setState({ lusTypes: response.data });
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    listPublishedTochtenByFilter(filter) {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        const loadOverzichtLayout = context.props.loadOverzichtLayout;

        ajaxActions.started();
        tochtApi.ListPublishedTochtenByFilter(filter)
            .then((response) => {
                ajaxActions.ended();
                this.processModel(response);
                loadOverzichtLayout();
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    createFilter(provincieId, startDatum, eindDatum, pageNumber, pageSize) {
        return {
            provincieId,
            startDatum: startDatum ? moment(startDatum, "DD-MM-YYYY") : null,
            eindDatum: eindDatum ? moment(eindDatum, "DD-MM-YYYY") : null,
            pageNumber,
            pageSize,
            tochtTypeId: null,
            lusTypeId: null
        };
    }

    processModel(response) {
        const context = this.context;

        if (response.data.hasValidationErrors) {
            context.setState({
                errors: response.data.validationResults,
            });
        }
        else {
            context.setState({
                model: response.data.item,
                errors: null
            });
        }
    }

    onChange(event) {
        const context = this.context;
        const value = event.target.value;
        const property = event.target.name;
        let model = context.state.model;

        model.filter[property] = value;

        if (property === "tochtTypeId")
            model.filter.lusTypeId = null;

        context.setState({
            model
        });
    }

    onSearch() {
        let filter = this.context.state.model.filter;
        filter.pageNumber = 1;

        this.listPublishedTochtenByFilter(filter);
    }

    onMeerTochten() {
        const context = this.context;
        const state = context.state;
        const ajaxActions = context.props.ajaxActions;
        let model = state.model;
        const page = model.filter.pageNumber + 1;

        let filter = model.filter;
        filter.pageNumber = page;

        ajaxActions.started();
        tochtApi.ListPublishedTochtenByFilter(filter)
            .then((response) => {
                ajaxActions.ended();

                const newModel = response.data;

                let tochten = model.tochten;
                tochten.push(...newModel.item.tochten);


                model = Object.assign({}, model, { tochten: tochten, filter: Object.assign({}, model.filter, { pageNumber: page }) });

                context.setState({
                    model
                });
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
        }
}
